// extracted by mini-css-extract-plugin
export default {"rightSide":"feedbacks_rightSide__z8A0S"};